let HOST = 'https://xhdcn-api-test.app.xinhuanet.com'
let BASE_URL = '/'
let XHH_HOST = 'https://my-api-test.app.xinhuanet.com'
let XHH_H5_HOST = 'https://my-h5news-test.app.xinhuanet.com'
if (process.env.NODE_ENV !== 'development') {
    HOST = process.env.VUE_APP_HOST
    BASE_URL = process.env.VUE_APP_BASE_URL
    XHH_HOST = process.env.VUE_APP_XHH_HOST
    XHH_H5_HOST = process.env.VUE_APP_XHH_H5_HOST
}
export {
    HOST,
    BASE_URL,
    XHH_HOST,
    XHH_H5_HOST
}